<template>
  <router-view></router-view>
</template>

<script>
export default {
	name: 'Usuarios',
	title: 'Usuários'
}
</script>

<style scoped>
</style>
